import { Throbber } from 'app/components/throbber';
import { useI18n } from 'core/hooks/useI18n';
import { Routing } from 'core/routing/Routing';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

const ConfigReports = lazy(() => import('./configuration/pages/reports/Reports'));
const ReportDetails = lazy(() => import('./configuration/pages/reports/details/ReportDetails'));
const LinkedVariables = lazy(() => import('./configuration/pages/reports/LinkedVariables'));

export function ReportsRoutes() {
  const { l10n } = useI18n('app');
  return (
    <Route
      path={Routing.routes.configuration.reporting.reports.root}
      element={
        <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
          <ConfigReports />
        </Suspense>
      }
    >
      {[
        Routing.routes.configuration.reporting.reports.createNew,
        Routing.routes.configuration.reporting.reports.details,
      ].map(path => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
              <ReportDetails />
            </Suspense>
          }
        />
      ))}

      <Route
        path={Routing.routes.configuration.reporting.reports.linkedVariables}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
            <LinkedVariables />
          </Suspense>
        }
      />
    </Route>
  );
}
